import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormHelperText,
  Grid2,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import "../index.css";
import BASEURL from "../../../../pages/Utils/Baseurl";
import request from "graphql-request";
import {
  getPaymentCollectionData,
  submitPaymentCollectionData,
} from "./paymentData";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialButton from "../../../../components/MaterialButton";
import Swal from "sweetalert2";

const PaymentCollectionForm = () => {
  const today = new Date().toISOString().split("T")[0];
  const location = useLocation();
  const navigate = useNavigate();

  const [balanceData, setBalanceData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchpaymentCollectionData();
  }, []);

  //Fetch Payment Collection Data by passing Customer ID
  const fetchpaymentCollectionData = async () => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, getPaymentCollectionData, {
        customerCode: location.state?.id,
        repcode: location.state?.repCode,
      });

      const invoiceData =
        response?.getPaymentBalanceCustomerCode?.data?.[0]?.invoices;

      if (Array.isArray(invoiceData)) {
        const formatted = invoiceData.map((invoice, index) => ({
          sno: index + 1,
          id: invoice.id,
          date: invoice.soDate,
          invoiceNumber: invoice.invoiceNumber,
          balanceAmount: invoice.balance,
          paymentAmount: "",
          remainingAmount: invoice?.remainingAmount,
          paymentStatus: invoice?.paymentStatus,
        }));

        setBalanceData(formatted);
      }
      setCustomerData(response?.getPaymentBalanceCustomerCode?.data?.[0]);
    } catch (error) {
      console.error("Error Fetching Data: ", error);
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Sorry! Network Issue",
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  //Update Mutation Function
  const submitDataHandle = async () => {
    const updates = balanceData
      ?.filter(
        (item) => item.paymentAmount && parseFloat(item.paymentAmount) > 0
      )
      .map((item) => ({
        id: item.id.toString(),
        partialPaidAmount: item.paymentAmount,
        uploadedAt: today,
      }));

    try {
      const response = await request(BASEURL, submitPaymentCollectionData, {
        input: { updates },
      });

      //Success and Error Messages
      const message = response.updatePaymentBalance?.message;
      if (response.updatePaymentBalance?.success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
      navigate("/paymentBalance");
    } catch (error) {
      console.error("Error Submitting Data: ", error);
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Sorry! Network Issue",
        showConfirmButton: true,
      });
    }
  };

  //Validation for Update Button
  const checkField = balanceData.some(
    (row) => parseFloat(row.paymentAmount) > parseFloat(row.balanceAmount)
  );

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Payment Collection Details
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "80vh" }}>
          <MaterialBox>
            <div className="customer-details">
              <p>
                <strong>Customer Code:</strong> {customerData?.customerCode}
              </p>
              <p>
                <strong>Customer Name:</strong> {customerData?.customerName}
              </p>
              <p>
                <strong>Credit Limit:</strong> {customerData?.creditLimit}
              </p>
              <p>
                <strong>Category:</strong> {customerData?.category}
              </p>
              <p>
                <strong>Age Of Invoice:</strong> {customerData?.ageOfInvoice}
              </p>
              <p>
                <strong>N days :</strong> {customerData?.ndays}
              </p>
              <p>
                <strong>Total Paid Amount:</strong> {customerData?.totalBalance}
              </p>
            </div>
            <div>
              <table className="invoice-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Invoice Number</th>
                    <th>SO Date</th>
                    <th>Balance Amount</th>
                    <th>Payment Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {balanceData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.sno}</td>
                      <td>{row.invoiceNumber}</td>
                      <td>{row.date}</td>
                      <td>{row.remainingAmount}</td>

                      <td>
                        {row?.paymentStatus?.toLowerCase() != "completed" ? (
                          <>
                            <MaterialInput
                              type="number"
                              value={row.paymentAmount}
                              error={
                                parseFloat(row.paymentAmount) >
                                parseFloat(row.remainingAmount)
                              }
                              inputProps={{ min: 0 }}
                              onChange={(e) => {
                                const value = e.target.value;
                                const updated = [...balanceData];
                                updated[index].paymentAmount = value;
                                setBalanceData(updated);
                              }}
                            />
                            {parseFloat(row.paymentAmount) >
                            parseFloat(row.remainingAmount) ? (
                              <FormHelperText error>
                                Payment amount cannot exceed Balance amount
                              </FormHelperText>
                            ) : (
                              <FormHelperText>
                                Enter a value that's less than Balance Amount
                              </FormHelperText>
                            )}
                          </>
                        ) : (
                           <p style={{color:"#2a9941",fontWeight:"600"}}>Paid</p>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={() => navigate("/paymentBalance")}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={submitDataHandle}
                disabled={checkField}
              >
                Update
              </MaterialButton>
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default PaymentCollectionForm;
